// extracted by mini-css-extract-plugin
module.exports = {"insertion":"Insertion_insertion__3V7dK","content":"Insertion_content__2Sdp1"};